/* eslint-disable react-refresh/only-export-components */
import { createContext, type ReactNode, useContext } from 'react';

import type { AppDependencies } from '../infrastructure/appDependencies';

interface AppDependenciesProviderProps {
  children: ReactNode;
  value: AppDependencies;
}

const AppDependenciesContext = createContext<AppDependencies | null>(null);

export const AppDependenciesProvider = ({ children, value }: AppDependenciesProviderProps) => (
  <AppDependenciesContext.Provider value={value}>{children}</AppDependenciesContext.Provider>
);

export const useAppDependencies = (): AppDependencies => {
  const value = useContext(AppDependenciesContext);
  if (!value) {
    throw new Error(
      'AppDependencies is not initialized. Wrap your app with AppDependenciesProvider.'
    );
  }

  return value;
};
